import { useLayoutEffect, useState } from "react";

const useDeviceDetection = () => {
  const [screenWidth, setScreeWidth] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useLayoutEffect(() => {
    const handleResize = () => {
      setScreeWidth(window.innerWidth);
      setIsMobile(window.innerWidth < 769);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { isMobile, screenWidth };
};

export default useDeviceDetection;
